const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const RelatedList = require('module/user/related_list')
const log = require('log').create('metalist') // eslint-disable-line

// this collection extend relatedlist with adding a save method to save the whole collection

const MetaList = RelatedList.extend({

    update(models) {
        if (! _.isEqual(this.toJSON(), models)) {
            this.reset(models)
            this.trigger('change')
            this.save()
        }
    },

    save(options) {
        return Backbone.sync.apply(this, ['update', this, options])
    },

})


module.exports = MetaList
